import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ThemePalette } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';

export interface StateSnackBarData {
  action?: { text: string; icon?: undefined } | { text?: undefined; icon: string };
  duration?: number;
  icon?: string;
  message?: string;
  subMessage?: string;
  type: 'success' | 'error' | 'info';
}

@Component({
  selector: 'app-state-snack-bar',
  standalone: true,
  imports: [CommonModule, MatIconModule, ProgressBarComponent, MatButtonModule, ProgressBarComponent],
  templateUrl: './state-snack-bar.component.html',
  styleUrls: ['./state-snack-bar.component.scss'],
})
export class StateSnackBarComponent {
  // Wir verwenden inject(), die moderne Art, Abhängigkeiten in Standalone-Komponenten zu bekommen
  data: StateSnackBarData = inject(MAT_SNACK_BAR_DATA);
  ref = inject(MatSnackBarRef<StateSnackBarComponent>);

  get message(): string {
    if (this.data.message?.length) {
      return this.data.message;
    } else {
      switch (this.data.type) {
        case 'error':
          return 'Ein Fehler ist aufgetreten';
        case 'success':
          return 'Die Änderungen wurden gespeichert';
        default:
          return ''; // Leeren String statt null zurückgeben
      }
    }
  }

  get color(): ThemePalette {
    switch (this.data.type) {
      case 'error':
        return 'warn';
      case 'success':
        return 'accent';
      case 'info':
        return 'primary';
      default:
        return 'primary';
    }
  }

  get icon(): string {
    if (this.data.icon?.length) {
      return this.data.icon;
    } else {
      switch (this.data.type) {
        case 'error':
          return 'error';
        case 'info':
          return 'info';
        case 'success':
          return 'check_circle';
        default:
          return '';
      }
    }
  }
}
